import { navigate } from 'gatsby';
import React, { useState } from 'react';
import {
  Box,
  Button,
  makeStyles,
  createStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { CustomTextField } from '../../../components/custom-text-field/custom-text-field';
import { Link } from 'gatsby-theme-material-ui';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

const useStyles = makeStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 308,
    },
    button: {
      backgroundColor: palette.warning.light,
    },
    buttonProgress: {
      color: palette.primary.light,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  })
);

export const ContactForm = () => {
  const classes = useStyles();
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');


  const validateEmail = () => {
    setEmailError('');
    if (!email.trim()) {
      return setEmailError('Email is required.');
    }
    if (!email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
      setEmailError(
        'Invalid email address. Check your spelling or try another one.'
      );
    }
  };


  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailError('');
    setEmail(event.target.value);
  };

  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!emailError) {
      if (!email.trim()) {
        return validateEmail();
      }

      try {
        localStorage.setItem('clientEmail', email);
        trackCustomEvent({
          category: "Discount Offer",
          action: "Click",
          label: "Get Started - Left Contact Info",
        })
        navigate('/trainers/');
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <Box className={classes.root}>
      <form onSubmit={handleFormSubmit}>
        <CustomTextField
          onChange={handleEmailChange}
          onBlur={validateEmail}
          value={email}
          type="email"
          name="email"
          autoComplete="email"
          fullWidth
          label="Email"
          hiddenLabel
          error={!!emailError}
          helperText={emailError}
        />
        <Box mt={3} />

        <Button
          className={classes.button}
          fullWidth
          variant="contained"
          size="large"
          color="default"
          disableElevation
          type="submit"
        >
          Get Started
        </Button>
        <Box mt={1} />
        <Typography variant="caption" color="inherit">
          By clicking Get Started you are agreeing to HabFit’s{' '}
          <Link underline="always" color="inherit" to="/terms-of-use/">
            Terms of Use
          </Link>{' '}
          &{' '}
          <Link underline="always" color="inherit" to="/privacy-policy/">
            Privacy Policy
          </Link>
        </Typography>
      </form>
    </Box>
  );
};
